<template>
  <div class="course">
    <Banner page="course"/>
    <!-- 课程列表 -->
    <CourseGoodsList :status="2">
      <div slot="title">
        <a-icon type="fire" theme="twoTone" />
        <h3 class="title">推荐课程</h3>
      </div>
    </CourseGoodsList>

    <CourseGoodsList :type="0">
      <div slot="title">
        <a-icon type="calculator" theme="twoTone" />
        <h3 class="title">入门课程</h3>
      </div>
    </CourseGoodsList>

    <CourseGoodsList :type="1">
      <div slot="title">
        <a-icon type="rocket" theme="twoTone" />
        <h3 class="title">进阶课程</h3>
      </div>
    </CourseGoodsList>
    <!-- TODO 单页课程 -->
  </div>
</template>

<script>
import Banner from "../../components/Banner";
import CourseGoodsList from "@/components/course/CourseGoodsList";

export default {
  name: "CourseGoods",
  components: {
    Banner,
    CourseGoodsList
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style land="less" scoped>
</style>